import React, { useCallback, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Grid } from '@material-ui/core';
import { RMSSelect, RMSCheckbox, RMSTextField } from '../../../shared/components/form-controls';
import { DICT_SELECT_PROPS } from '../../constants/personPhotoFormConstants';
import useUserDictionaryOptions from '../../hooks/useUserDictionaryOptions';
import { getDefaultMugshotType } from 'reducers/AgencySettingsReducer';

const PersonPhotoMetaFields = ({
  hasDefaultPhoto,
  forceMark = false,
  defaultToMarksType = false,
}) => {
  const { control, setValue, getValues } = useFormContext();
  const {
    mugshotTypeOptions,
    markTypeOptions,
    markLocationOptions,
    gangOptions,
  } = useUserDictionaryOptions();
  const watchedIsMark = useWatch({ control, name: 'IsMark' });
  const watchedImageTypeCode = useWatch({ control, name: 'ImageTypeCode' });
  const isMark = forceMark || watchedIsMark;

  const handleIsMarkChange = useCallback(
    (e) => {
      if (e.target.checked) {
        setValue('IsDefault', false);
      }
    },
    [setValue]
  );

  const handleIsDefaultChange = useCallback(
    (e) => {
      if (
        e.target.checked &&
        hasDefaultPhoto &&
        !window.confirm(
          'This record already has a default photo. Would you like to make this photo the default instead?'
        )
      ) {
        setValue('IsDefault', false);
      }
    },
    [hasDefaultPhoto, setValue]
  );

  useEffect(() => {
    if (!defaultToMarksType || getValues('ImageTypeCode')) return;

    const marksDefault = mugshotTypeOptions.find(
      (option) => option.Category?.toLowerCase() === 'marks'
    );

    if (marksDefault) {
      setValue('ImageTypeCode', marksDefault.Code);
    }
  }, [defaultToMarksType, mugshotTypeOptions, getValues, setValue]);

  useEffect(() => {
    if (isMark) return;

    const defaultMugshotType = getDefaultMugshotType();
    if (!defaultMugshotType) return;

    setValue('IsDefault', watchedImageTypeCode === defaultMugshotType);
  }, [watchedImageTypeCode, isMark, setValue]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <RMSSelect
          name="ImageTypeCode"
          label="Image Type"
          options={mugshotTypeOptions}
          {...DICT_SELECT_PROPS}
        />
      </Grid>
      <Grid item xs={12}>
        <RMSTextField name="Description" label="Description" multiline rows={2} />
      </Grid>
      {!forceMark && (
        <>
          <Grid item xs={6}>
            <RMSCheckbox
              name="IsMark"
              label="Scar, Mark, or Tattoo"
              onChange={handleIsMarkChange}
            />
          </Grid>
          <Grid item xs={6}>
            <RMSCheckbox
              name="IsDefault"
              label="Is Default"
              disabled={isMark}
              onChange={handleIsDefaultChange}
            />
          </Grid>
        </>
      )}
      {isMark && (
        <>
          <Grid item xs={6}>
            <RMSSelect
              name="MarkType"
              label="Mark Type"
              options={markTypeOptions}
              {...DICT_SELECT_PROPS}
            />
          </Grid>
          <Grid item xs={6}>
            <RMSSelect
              name="Location"
              label="Location"
              options={markLocationOptions}
              {...DICT_SELECT_PROPS}
            />
          </Grid>
          <Grid item xs={6}>
            <RMSSelect name="Gang" label="Gang" options={gangOptions} {...DICT_SELECT_PROPS} />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default PersonPhotoMetaFields;
